import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { Alert, AlertService } from '@michelin/theme';
import { DistributorFormComponent } from 'src/app/pages/distributor/components/distributor-form/distributor-form.component';
import { ProductLineDto } from 'src/app/shared/models/product-line/product-line-dto';
import { StateDto } from 'src/app/shared/models/location/state-dto';
import { DistributorService } from 'src/app/shared/services/distributor/distributor.service';
import { ProductLineService } from 'src/app/shared/services/product-line/product-line.service';
import { LocationService } from 'src/app/shared/services/location/location.service';
import { DistributorDto } from 'src/app/shared/models/distributor/distributor-dto';
import { UserService } from 'src/app/shared/services/user/user.service';
import { AccountManagerService } from 'src/app/shared/services/distributor/account-manager.service';
import { AccountManagerDto } from 'src/app/shared/models/distributor/account-manager-dto';

@Component({
    selector: 'app-update-distributor',
    templateUrl: './update-distributor.component.html',
    standalone: false
})
export class UpdateDistributorComponent implements OnInit {
  loading: boolean = false;
  distributorId: number = 0;

  data = {
    users: [] as any[],
    productLines: [] as ProductLineDto[],
    states: [] as StateDto[],
    distributor: {} as DistributorDto,
    accountManagers: [] as AccountManagerDto[]
  };

  @ViewChild(DistributorFormComponent) distributorForm: DistributorFormComponent;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly alertService: AlertService,
    private readonly distributorService: DistributorService,
    private readonly userService: UserService,
    private readonly productLineService: ProductLineService,
    private readonly locationService: LocationService,
    private readonly accountManagerService: AccountManagerService
  ) {}

  submitForm() {
    this.loading = true;
    this.distributorService
      .update(this.distributorId, this.distributorForm.formValues)
      .subscribe({
        next: () =>
          this.alertService.showAlert({
            type: 'success',
            content: 'Dist. Exclusivo atualizada com sucesso'
          } as Alert),
        error: () => {
          this.alertService.showAlert({
            type: 'critical',
            content: 'Ocorreu um erro ao atualizar o Dist. Exclusivo'
          } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }

  refreshAccountManager() {
    this.loading = true;
    this.accountManagerService
      .findByDistributorId(this.distributorId)
      .subscribe({
        next: (accountManagers) => {
          this.data.accountManagers = accountManagers;
        },
        error: () => {
          this.alertService.showAlert({ content: 'Ocorreu um erro ao carregar os Account Managers', type: 'critical' } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }

  ngOnInit() {
    this.loading = true;
    this.distributorId = this.activatedRoute.snapshot.params['id'];

    forkJoin({
      users: this.userService.findAll(),
      productLines: this.productLineService.findAll(),
      states: this.locationService.findAllStates(),
      distributor: this.distributorService.findById(this.distributorId),
      accountManagers: this.accountManagerService.findByDistributorId(this.distributorId)
    })
      .subscribe({
        next: (result) => (this.data = result),
        complete: () => this.distributorForm.loadFormValues(this.data.distributor),
        error: () => this.alertService.showAlert({ content: 'Ocorreu um erro ao carregar algumas informações', type: 'critical' } as Alert)
      })
      .add(() => (this.loading = false));
  }
}
